import { useNavigate } from 'react-router-dom';
import { ChangePasswordForm } from '~/components/ChangePassword';
import { Layout } from '~/components/SignUp';
import { HelmetHead } from '~/components/common';
import { PAGE_ROUTE } from '~/constants';

export default function ChangePassword() {
  const navigate = useNavigate();

  return (
    <>
      <HelmetHead title='Change Password' />

      <Layout title={'Change your password'}>
        <ChangePasswordForm
          onNextStep={() => navigate(PAGE_ROUTE.PASSWORD_SUCCESS)}
        />
      </Layout>
    </>
  );
}
